module.exports = __webpack_public_path__ + "static/media/weAct.3495e5c2.png";